<template>
    <div>
        <div class="form-group">
            <label for="address_line_1">Find Address:</label>
            <input
                type="text"
                :id="findAddressId"
                placeholder="Find address"
                @focus="geolocate()"
                class="form-control"
            >
            <small class="form-text">Start typing to find the address and autofill the form below</small>
        </div>
        <hr>
        <div class="form-group">
            <label for="address_line_1">Address line 1:</label>
            <input
                type="text"
                id="address_line_1"
                placeholder="Address line 1"
                v-model="address.address_line_1"
                class="form-control"
                :class="{ 'is-invalid' : errors.address_line_1 }"
            >
            <error
                name="address_line_1"
                :errors="errors"
            />
        </div>
        <div class="form-group">
            <label for="address_line_2">Address line 2:</label>
            <input
                type="text"
                id="address_line_2"
                placeholder="Address line 2"
                v-model="address.address_line_2"
                class="form-control"
                :class="{ 'is-invalid' : errors.address_line_2 }"
            >
            <error
                name="address_line_2"
                :errors="errors"
            />
        </div>
        <div class="form-group">
            <label for="address_line_3">Address line 3:</label>
            <input
                type="text"
                id="address_line_3"
                placeholder="Address line 3"
                v-model="address.address_line_3"
                class="form-control"
                :class="{ 'is-invalid' : errors.address_line_3 }"
            >
            <error
                name="address_line_3"
                :errors="errors"
            />
        </div>
        <div class="form-group">
            <label for="town">Town:</label>
            <input
                type="text"
                id="town"
                placeholder="Town"
                v-model="address.town"
                class="form-control"
                :class="{ 'is-invalid' : errors.town }"
            >
            <error
                name="town"
                :errors="errors"
            />
        </div>
        <div class="form-group">
            <label for="region">Region:</label>
            <input
                type="text"
                id="region"
                placeholder="Region"
                v-model="address.region"
                class="form-control"
                :class="{ 'is-invalid' : errors.region }"
            >
            <error
                name="region"
                :errors="errors"
            />
        </div>
        <div class="form-group">
            <label for="country">Country:</label>
            <input
                type="text"
                id="country"
                placeholder="Country"
                v-model="address.country"
                class="form-control"
                :class="{ 'is-invalid' : errors.country }"
            >
            <error
                name="country"
                :errors="errors"
            />
        </div>
        <div class="form-group">
            <label for="postcode">Postcode:</label>
            <input
                type="text"
                id="postcode"
                placeholder="Postcode"
                v-model="address.postcode"
                class="form-control"
                :class="{ 'is-invalid' : errors.postcode }"
            >
            <error
                name="postcode"
                :errors="errors"
            />
        </div>
        <div class="form-group">
            <label>Coordinates</label>
            <div class="row mb-2">
                <div class="col-sm-6">
                    <label for="lat">Latitude</label>
                    <input
                        type="number"
                        v-model="address.lat"
                        class="form-control"
                        formnovalidate
                        step="0.0000000000000001"
                        @change="initMap"
                    >
                </div>
                <div class="col-sm-6">
                    <label for="lng">Longitude</label>
                    <input
                        type="number"
                        v-model="address.lng"
                        class="form-control"
                        formnovalidate
                        step="0.0000000000000001"
                        @change="initMap"
                    >
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-sm-12">
                    <label for="lng">What3Words:</label>
                    <input
                        type="text"
                        v-model="address.w3w"
                        class="form-control"
                        formnovalidate
                        v-debounce:1000ms="convertFromW3Words"
                    >
                    <small
                        class="form-error"
                        v-if="w3wError"
                    >{{ w3wError }}</small>
                    <a
                        v-if="address.w3w"
                        :href="`https://what3words.com/${address.w3w}`"
                        target="_blank"
                    >View on What3Words</a>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div
                        class="site-map"
                        id="site-map"
                        style="height: 300px; width: 100%;"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorComponent from "../ErrorComponent";

export default {

    name: 'AddressForm',

    components: {
        'error': ErrorComponent,
    },
    props: ["address", "errors",],

    data: function () {
        return {
            findAddressId: 'find_address_' + this._uid,
            map: null,
            mapMarker: null,
            w3wError: undefined,
        };
    },

    watch: {
        address() {
            this.setMapMarker();
        },
    },

    mounted: function () {
        this.initAutocomplete();
        this.initMap();
    },
    methods: {
        geolocate: function () {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    var geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    var circle = new window.google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy
                    });
                    this.autocomplete.setBounds(circle.getBounds());
                });
            }
        },

        initAutocomplete: function () {
            this.autocomplete = new window.google.maps.places.Autocomplete(
                document.getElementById(this.findAddressId),
                {types: ["geocode"]}
            );
            this.autocomplete.setFields(['address_component', 'geometry']);
            this.autocomplete.addListener("place_changed", () => {
                this.fillAddress();
            });
        },

        fillAddress: function () {
            let place = this.autocomplete.getPlace();
            let address = {};
            if (place.address_components) {
                for (let line_no in place.address_components) {
                    var line = place.address_components[line_no];
                    address[line.types[0]] = line.long_name;
                }
                this.address.address_line_1 = '';
                if (address.street_number) {
                    this.address.address_line_1 += address.street_number + ' ';
                }
                if (address.route) {
                    this.address.address_line_1 += address.route;
                }
                this.address.address_line_2 = address.locality;
                this.address.address_line_3 = "";
                this.address.town = address.postal_town;
                this.address.region = address.administrative_area_level_2;
                this.address.country = address.country;
                this.address.postcode = address.postal_code;
                if (place.geometry.location) {
                    this.address.lat = place.geometry.location.lat();
                    this.address.lng = place.geometry.location.lng();
                    this.getW3Words();
                    this.setMapMarker();
                }
            }
        },

        initMap: function () {
            this.map = new window.google.maps.Map(
                document.getElementById("site-map"),
                {
                    zoom: 13,
                    center: {
                        lat: 52.3555,
                        lng: -1.1743
                    }
                }
            );
            this.map.addListener('click', event => {
                this.address.lat = event.latLng.lat();
                this.address.lng = event.latLng.lng();
                this.getW3Words();
                this.setMapMarker();
            });
            this.setMapMarker();
        },

        setMapMarker: function () {
            if (this.mapMarker) {
                this.mapMarker.setMap(null);
            }
            if (!this.address.lat || !this.address.lng) {
                return;
            }
            const coords = {
                lat: parseFloat(this.address.lat),
                lng: parseFloat(this.address.lng),
            };
            this.map.setCenter(coords);
            this.map.setZoom(15);
            this.mapMarker = new window.google.maps.Marker({
                position: coords,
                map: this.map,
            });
        },

        getW3Words: async function () {
            if (!window.env.MIX_W3W_API_KEY) {
                console.warn('No W3W API key set')
                return;
            }
            this.w3wError = undefined;
            try {
                const w3wResponse = await fetch(`https://api.what3words.com/v3/convert-to-3wa?coordinates=${this.address.lat}%2C${this.address.lng}&key=${window.env.MIX_W3W_API_KEY}`,)
                const wswData = await w3wResponse.json();
                this.address.w3w = wswData.words;
            } catch (e) {
                this.w3wError = 'Error getting What3Words';
                console.error(e)
                this.address.w3w = '';
            }
        },

        convertFromW3Words: async function () {
            this.w3wError = undefined;
            if (!this.address.w3w) {
                return;
            }
            if (!window.env.MIX_W3W_API_KEY) {
                console.warn('No W3W API key set')
                return;
            }
            fetch(`https://api.what3words.com/v3/convert-to-coordinates?words=${this.address.w3w}&key=${window.env.MIX_W3W_API_KEY}`).then((w3wResponse => {
                if (w3wResponse.status === 400) {
                    this.w3wError = 'Not a valid What3Words';
                } else if (!w3wResponse.ok) {
                    this.w3wError = 'Error getting coordinates from What3Words';
                }
                if (w3wResponse.status.ok) {
                    w3wResponse.json().then(w3wData => {
                        this.address.lat = w3wData.coordinates.lat;
                        this.address.lng = w3wData.coordinates.lng;
                        this.address.w3w = w3wData.words;
                        this.setMapMarker();
                    });
                }
            }))

        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/AddressForm.vue